import firebase from 'firebase/app'

import "firebase/auth"
import "firebase/database"

export default firebase